import { CaretDownIcon } from "@phosphor-icons/react/dist/csr/CaretDown";
import { Link } from "react-router-dom";
import { Button } from "@volca/ui/components/ui/button";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@volca/ui/components/ui/collapsible";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { canManageReport } from "@/profitability/access";
import { profitabilityTemplateEditPath } from "@/profitability/routes";
import { DescriptionEditor } from "@/profitability/template-page/description-editor";
import type { ProfitabilityReport } from "@/profitability/types";
import { SettingsGroup } from "./settings-group";

export const AgentInstructions = ({
  businessId,
  report,
}: {
  businessId: string;
  report: ProfitabilityReport;
}) => (
  <SettingsGroup title="Advanced">
    <Collapsible>
      <CollapsibleTrigger
        render={
          <Button
            variant="ghost"
            className="h-auto min-h-11 w-full justify-between px-4 py-3"
          />
        }
      >
        View build instructions
        <CaretDownIcon aria-hidden className="in-data-open:rotate-180" />
      </CollapsibleTrigger>
      <CollapsibleContent keepMounted>
        <Stack gap={4} className="p-4">
          <Text tone="muted" className="text-pretty">
            Changes to these instructions create a draft version for review.
          </Text>
          <DescriptionEditor businessId={businessId} report={report} />
          {canManageReport(report) && (
            <Stack direction="row">
              <Button
                variant="outline"
                render={<Link to={profitabilityTemplateEditPath(report.id)} />}
              >
                Edit with Volca
              </Button>
            </Stack>
          )}
        </Stack>
      </CollapsibleContent>
    </Collapsible>
  </SettingsGroup>
);
